export default __webpack_public_path__ + "static/media/filter.52b2d4a5.svg";